module.exports = "<!-- This is an abstract template and should not be used directly-->\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/components/widget/abstract-form-widget/abstract-form-widget.component.html
// module id = ../../../../../src/app/shared/components/widget/abstract-form-widget/abstract-form-widget.component.html
// module chunks = main